import { module } from 'modujs';
import Vlitejs from 'vlitejs';
import VlitejsYoutube from 'vlitejs/providers/youtube.js';
import VlitejsVimeo from 'vlitejs/providers/vimeo.js';
Vlitejs.registerProvider('youtube', VlitejsYoutube);
Vlitejs.registerProvider('vimeo', VlitejsVimeo);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.guid = this.el.getAttribute('data-module-player');
        this.playerType = this.el.getAttribute('data-type');
        this.playerElt = this.el.querySelector('#player-' + this.guid);
        this.provider = this.playerElt.getAttribute('data-player-provider');
        this.player = null;
    }

    play() {
        if (this.player) {
            this.player.player.play();
        } else {
            let that = this;
            this.player = new Vlitejs(this.playerElt, {
                options: {
                    controls: true,
                    autoplay: false,
                    playPause: false,
                    bigPlay: false,
                    playsinline: true,
                    loop: true,
                    autoHide: true,
                    providerParams: { showinfo: 0, rel: 0, modestbranding: 1 }
                },
                provider: this.provider,
                onReady: function (player) {
                    that.playerReady();
                },
            });
        }
    }

    playerReady () {
        this.player.player.play();
        this.player.player.unMute();
        this.player.player.setVolume(1);
    }

    pause() {
        if (this.player) {
            this.player.player.pause();
        }
    }
}
